import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ag1-bettabase-error',
  templateUrl: './ag1-bettabase-error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class Ag1BettabaseErrorComponent {
  @Input() errorName: string = 'An error occurred';
  @Input() errorMessage: string = 'An unexpected error occurred';

  getErrorIcon(): string {
    switch (this.errorName.toLowerCase()) {
      case 'chart timed out':
        return '⏳';
      case 'no data to display':
        return '🪹';
      case 'too much data to display (ram risk)':
        return '📈';
      case 'server error':
        return '🖥️';
      case 'unauthorized':
        return '🔒';
      default:
        return '⚠️';
    }
  }
}
